<template>
  <div>
    <div class="row">
      <b-form-group label="Record type" :label-for="id('type')" class="col-sm-4">
        <b-form-select :id="id('type')" v-model="type" :options="types.map(value => ({value, text: label(value)}))" @change="search(1)"/>
      </b-form-group>
      <b-form-group label="Search by name" :label-for="id('query')" class="col-sm-8">
        <b-input-group>
          <b-form-input :id="id('query')" v-model="query" @keydown.enter.prevent="search(1)"/>
          <b-input-group-append><b-btn type="button" variant="outline-primary" :disabled="loading" @click="search(1)">Search</b-btn></b-input-group-append>
        </b-input-group>
      </b-form-group>
    </div>
    <p v-if="value" class="small">Selected {{ label(value.type) }}: <strong>{{ entityName(value) }}</strong> {{ entityAddress(value) }}</p>
    <p v-if="loading" role="status">Loading records...</p>
    <b-alert v-else-if="error" show variant="danger">{{ error }} <b-btn size="sm" variant="link" @click="search(requestedPage)">Retry</b-btn></b-alert>
    <template v-else-if="loaded">
      <p class="small text-muted">{{ meta.total || 0 }} matching records</p>
      <p v-if="!items.length">No records found.</p>
      <div v-for="item in items" :key="`${item.type}:${item.id}`" class="border-bottom py-2">
        <b-form-radio :checked="value && value.id" :name="id('target')" :value="item.id" :disabled="supplierIdentity && !item.source_record_id" @change="$emit('input', item)">
          {{ entityName(item) }} <small>{{ label(item.type) }} · {{ entityAddress(item) || 'No address' }}</small>
        </b-form-radio>
        <small v-if="supplierIdentity && !item.source_record_id" class="text-muted">No supplier identity</small>
      </div>
      <b-pagination v-if="meta.total > (meta.per_page || 20)" :value="page" :total-rows="meta.total" :per-page="meta.per_page || 20" class="mt-2" @input="search"/>
    </template>
  </div>
</template>
<script>
import {API_ROUTES} from "../../api";
import {label, entityName, entityAddress, result, failure} from "./RegistryOperationSupport";
export default {
  name: "RegistryActionTargetPicker",
  props: {types: {type: Array, required: true}, value: {type: Object, default: null}, supplierIdentity: Boolean},
  data() { return {type: this.types[0], query: "", items: [], meta: {}, page: 1, requestedPage: 1, loading: false, loaded: false, error: "", request: 0}; },
  watch: {types() { this.type = this.types[0]; this.request++; this.items = []; this.meta = {}; this.loaded = false; this.loading = false; }},
  beforeDestroy() { this.request++; },
  methods: {
    label, entityName, entityAddress,
    id(field) { return `registry-target-${this._uid}-${field}`; },
    async search(page = 1) {
      const request = ++this.request;
      this.loading = true; this.error = ""; this.requestedPage = page;
      try {
        const response = await this.$api.get(API_ROUTES.ADMIN_LICENSE_REGISTRY_ENTITIES, {params: {type: this.type, name: this.query || undefined, page, per_page: 20}});
        if (request !== this.request) return;
        this.items = result(response); this.meta = response.data.meta || {}; this.page = this.meta.current_page || page; this.loaded = true;
      } catch (error) { if (request === this.request) this.error = failure(error, "Could not load records.").message; }
      finally { if (request === this.request) this.loading = false; }
    }
  }
};
</script>
